import React from "react";
import "./GuideProfile.css";
import "./GuideProfileSetting.css";
import { FaEnvelope, FaPhone, FaIdCard, FaMoneyBillWave, FaFlag, FaGlobe, FaPassport, FaShieldAlt, FaHotel, FaClipboardCheck, FaCalendarAlt, FaCoins, FaShareAlt, FaStar, FaUniversity } from "react-icons/fa";
import traveler from "../assets/traveller.png";
import NavUser from "../components/NavUser";

function LocalUser() {
  return (
    <div>
      <NavUser />
      <div className="guider-profile-container">
        {/* Profile Section */}
        <section className="guider-profile-header">
          <img src={traveler} alt="Guide" className="guider-profile-image" />
          <div className="guider-details">
            <h2 className="guider-name">John Doe</h2>
            <p className="guider-languages">Speaks: English, French, Spanish</p>
            <p className="guider-languages">Traveler | Local</p>
          </div>
        </section>

        {/* Two-column section */}
        <section className="guider-profile-body">
          <div className="guider-left-column">
            {/* Personal Info */}
            <h3 className="section-title">Personal Info</h3>

            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div className="info-text">
                <h4>Email</h4>
                <p>guide@example.com</p>
              </div>
            </div>

            <div className="info-item">
              <FaPhone className="info-icon" />
              <div className="info-text">
                <h4>Phone</h4>
                <p>+1 234 567 890</p>
              </div>
            </div>

            <div className="info-item">
              <FaFlag className="info-icon" />
              <div className="info-text">
                <h4>Nationality</h4>
                <p>Sri Lankan</p>
              </div>
            </div>

            <div className="info-item">
              <FaGlobe className="info-icon" />
              <div className="info-text">
                <h4>Country of Residence</h4>
                <p>Sri Lanka</p>
              </div>
            </div>

            <div className="info-item">
              <FaPassport className="info-icon" />
              <div className="info-text">
                <h4>Visa Status</h4>
                <p>VISA-ETA-2025-03821</p>
                <p>Approved</p>
              </div>
            </div>

            <div className="info-item">
              <FaIdCard className="info-icon" />
              <div className="info-text">
                <h4>National ID Status</h4>
                <p>234254545 v</p>
                <p>Approved</p>
              </div>
            </div>

            <div className="info-item">
              <FaShieldAlt className="info-icon" />
              <div className="info-text">
                <h4>Insurance Policy</h4>
                <p>Fairfirst Essential Plan</p>
              </div>
            </div>

            {/* Preferences */}
            <h3 className="section-title">Preferences</h3>

            <div className="info-item">
              <FaMoneyBillWave className="info-icon" />
              <div className="info-text">
                <h4>Default Currency</h4>
                <p>LKR</p>
              </div>
            </div>

            <div className="info-item">
              <FaHotel className="info-icon" />
              <div className="info-text">
                <h4>Preferred Stay</h4>
                <p>Boutique Hotels</p>
              </div>
            </div>
          </div>

          <div className="guider-right-column">
            {/* Activity */}
            <h3 className="section-title">Activity</h3>

            <div className="info-item">
              <FaClipboardCheck className="info-icon" />
              <div className="info-text">
                <h4>Total Bookings</h4>
                <p>7 Completed</p>
              </div>
            </div>

            <div className="info-item">
              <FaCalendarAlt className="info-icon" />
              <div className="info-text">
                <h4>Upcoming Trip</h4>
                <p>Ella Hiking Tour with Kamal - Aug 10, 6:00 AM</p>
              </div>
            </div>

            <div className="info-item">
              <FaCoins className="info-icon" />
              <div className="info-text">
                <h4>Coin Balance</h4>
                <p>120 Coins</p>
              </div>
            </div>

            <div className="info-item">
              <FaShareAlt className="info-icon" />
              <div className="info-text">
                <h4>Posts Shared</h4>
                <p>3 Travel Stories</p>
              </div>
            </div>

            <div className="info-item">
              <FaStar className="info-icon" />
              <div className="info-text">
                <h4>Total Reviews Left</h4>
                <p>5</p>
              </div>
            </div>

            {/* Payment */}
            <h3 className="section-title">Payment</h3>

            <div className="info-item">
              <FaUniversity className="info-icon" />
              <div className="info-text">
                <h4>Bank Account Number</h4>
                <p>123456789123, Bank of Ceylon</p>
              </div>
            </div>

            <div className="button-column">
              <button
                className="add-payment-btn"
                onClick={() => alert("Add Payment Clicked!")}
              >
                + Add Payment Details
              </button>
              <button
                className="add-payment-btn"
                onClick={() => alert("Add National ID Clicked!")}
              >
                ＋ Add National ID
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default LocalUser;
